import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { AnalyticsEventRow } from "@/hooks/useAnalyticsConversao";

interface Props {
  events: AnalyticsEventRow[];
}

const AlertasConversao: React.FC<Props> = ({ events }) => {
  const c = (fn: (e: AnalyticsEventRow) => boolean) => events.filter(fn).length;

  const pagVisits = c((e) => e.event_type === "page_view" && e.path === "/pagamento");
  const pagNubank = c((e) => e.event_type === "direct_payment_nubank_click");
  const pagWhats = c((e) => e.event_type === "direct_payment_whatsapp_click");
  const planosVisits = c((e) => e.event_type === "page_view" && e.path === "/planos");
  const stripeClicks = c((e) => e.event_type === "checkout_click" && e.metadata?.origin === "planos_stripe");
  const whatsTotal = c((e) => e.event_type === "whatsapp_click" || e.event_type === "direct_payment_whatsapp_click");
  const totalVisits = c((e) => e.event_type === "page_view");

  const alerts: string[] = [];

  if (pagVisits > 0 && pagNubank === 0) {
    alerts.push(`Existem ${pagVisits} visitas em /pagamento, mas nenhum clique no Nubank no período.`);
  }
  if (pagVisits > 0 && pagWhats === 0) {
    alerts.push(`Existem ${pagVisits} visitas em /pagamento, mas nenhum clique no WhatsApp no período.`);
  }
  if (planosVisits > 0 && stripeClicks === 0) {
    alerts.push(`Existem ${planosVisits} visitas em /planos, mas nenhum checkout Stripe no período.`);
  }
  if (totalVisits >= 20 && whatsTotal === 0) {
    alerts.push(`Há ${totalVisits} visitas mas nenhum clique em WhatsApp — possível queda de conversão.`);
  }
  if (totalVisits >= 50 && whatsTotal > 0 && whatsTotal / totalVisits < 0.01) {
    alerts.push(`Cliques no WhatsApp muito baixos (${whatsTotal} para ${totalVisits} visitas — abaixo de 1%).`);
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <AlertTriangle className="w-4 h-4 text-orange-500" />
          Alertas de Conversão
        </CardTitle>
      </CardHeader>
      <CardContent>
        {alerts.length === 0 ? (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <CheckCircle2 className="w-4 h-4 text-green-500" />
            Nenhum alerta no período selecionado.
          </div>
        ) : (
          <ul className="space-y-2">
            {alerts.map((a, i) => (
              <li key={i} className="text-sm flex items-start gap-2">
                <AlertTriangle className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
                <span>{a}</span>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default AlertasConversao;
